import React from 'react'


class LogRow extends React.Component
{
    adjustDateDisplay (date)
    {
       return new Date(date + 'Z').toLocaleString();
    }

    render() {
        let changeLog = this.props.changeLog ? this.props.changeLog.replace(/Request for Site change./, '$&,').split(',') : [];
        if (changeLog.length > 1) {
            const [a, ...b] = changeLog;
            changeLog = [...a.replace(/: /, '$&##').split('##'), ...b];
        }

        return(
            <div style={this.props.even? highlighted : normal}>
                 <div style={{fontSize: '12px'}} > 
                    <span style={dateStyle}>{this.adjustDateDisplay(this.props.changeDate)} </span> 
                    {   
                        this.props.user && 
                        <span><span style={{color: '#0078D4'}}>{this.props.user.email}</span>: </span>
                    }
                    <span>
                        {   
                            changeLog.map((x, index) => 
                                <span key={index}>{x}<br/></span>
                            )
                        }
                    </span> 
                </div>
            </div>
        );
    }
}
export default LogRow

const highlighted = {
    textAlign:'left',
    padding:'8px',
    backgroundColor: 'rgb(205, 230, 247)'
}

const normal = {
    textAlign:'left',
    padding:'8px',
}

const dateStyle = {
    color: 'rgb(120, 120, 120)'
}


// WEBPACK FOOTER //
// ./src/components/Administration/SiteDetails/LogRow.js